function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import ReactJson from 'react-json-view';
import { AppShell } from '../app-shell';
import LoadingIndicator from '../../components/loading-indicator/loading-indicator';
import classnames from 'classnames';
import { ProcessTimeline } from '@codametrix/shared-views';
import { ProcessSelection } from '@codametrix/shared-views';
import { sortCaseRuns } from '../../reducers/cases.reducer';
import { FlexCard } from '@codametrix/ui-components';
var _React_Component;
export class BPMStepsApp extends (_React_Component = React.Component) {
    componentDidMount() {
        const url = new URL(window.location.toString());
        const arg = {
            caseId: url.searchParams.get('caseId'),
            processInstanceId: url.searchParams.get('processInstanceId')
        };
        this.props.getBPMDetails(arg);
    }
    _handleProcessIdChange(event) {
        event.preventDefault();
        const target = event.target || document.createElement('div');
        const linkable = target?.closest('a');
        if (!linkable) return;
        const item = linkable.attributes.getNamedItem('data-process-id');
        if (!item) return;
        const processId = parseInt(item.value);
        if (!processId) return;
        if (processId !== this.props.activeCaseRun.process_instance_id) {
            this.props.setActiveProcessId(processId);
        }
    }
    render() {
        const { props } = this;
        const { loading, locked, stages, activeCase, activeCaseRun, showRawJSON } = props;
        const caseRuns = activeCase.caseRuns ? sortCaseRuns(activeCase, {}) : {};
        const styleClasses = [
            'centered-application',
            `bpm-steps-app`
        ];
        let inner;
        if (locked) {
            styleClasses.push(`cmx-application-locked`);
        }
        const jsonDisplay = {
            ruleResults: activeCaseRun.ruleResults,
            history: activeCaseRun.history
        };
        if (loading) {
            styleClasses.push(`cmx-application-masked`, `cmx-application-loading`, 'loading-view');
            inner = /*#__PURE__*/ _jsx(LoadingIndicator, {
                text: `Loading JSON...`
            });
        } else if (stages !== undefined) {
            styleClasses.push(`cmx-application-loaded`);
            inner = /*#__PURE__*/ _jsxs(FlexCard, {
                header: /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx("h5", {
                                children: "Processing Steps"
                            })
                        }),
                        /*#__PURE__*/ _jsx(ProcessSelection, {
                            caseRuns: caseRuns,
                            activeId: activeCaseRun.process_instance_id,
                            onClick: this._handleProcessIdChange
                        })
                    ]
                }, "selction"),
                children: [
                    !showRawJSON && /*#__PURE__*/ _jsx(ProcessTimeline, {
                        stages: stages
                    }),
                    showRawJSON && /*#__PURE__*/ _jsx(ReactJson, {
                        src: jsonDisplay,
                        displayObjectSize: false,
                        collapsed: false,
                        displayDataTypes: false,
                        theme: 'ocean'
                    })
                ]
            });
        }
        return /*#__PURE__*/ _jsx(AppShell, {
            registerActivity: props.registerActivity,
            children: /*#__PURE__*/ _jsxs("div", {
                className: classnames(styleClasses),
                children: [
                    locked && /*#__PURE__*/ _jsx("div", {
                        className: "locked-message",
                        children: "The case details you were viewing are no longer active."
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "centered-application-wrapper",
                        children: inner
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props);
        this._handleProcessIdChange = this._handleProcessIdChange.bind(this);
    }
}
_define_property(BPMStepsApp, "defaultProps", {
    loading: true
});
